import { setPageStateById } from '../PageContext';

export const setLoanSourceType = (setState: setPageStateById) => (loanSourceType) => {
  setState('SET_LOAN_SOURCE_TYPE', (s) => ({
    ...s,
    loanSourceType: loanSourceType,
  }));
};
